import { theme } from "@chakra-ui/react";

const baseProgressTheme = theme.components.Progress;

const baseStyle = {
  track: {
    bg: "gray.200",
    borderRadius: "md",
  },
  filledTrack: {
    bg: "blue",
    borderRadius: "md",
  },
};

const sizes = {
  xs: {
    track: { h: "4px" },
  },
  sm: {
    track: { h: "8px" },
  },
  md: {
    track: { h: "12px" },
  },
  lg: {
    track: { h: "16px" },
  },
  xl: {
    track: { h: "20px" },
  },
};

const variants = {
  solid: {
    track: {
      bg: "gray.200",
    },
    filledTrack: {
      bg: "blue",
    },
  },
};

export const progressTheme = {
  ...baseProgressTheme,
  baseStyle,
  sizes,
  variants,
};

export default progressTheme;
